import $ from 'jquery';

const LocalizationService = {
    RUSSIAN: 'ru',
    ENGLISH: 'en',
    language: 'ru',
    init() {
        this.language = $('html').attr('lang');
    },
    getLanguage() {
        return this.language;
    },
    getByLocale(data) {
        if (data[this.language] !== undefined) {
            return data[this.language];
        }
        return '';
    },
    is(language) {
        return this.language === language;
    }
};

LocalizationService.init();

export default LocalizationService;
